import * as React from 'react'
import ReactDOMServer from 'react-dom/server';

export const slugify: (str: string) => string = (str: string) =>
  str
    ? str
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '')
    : ''

export const camelize = (text: string) => {
  text = text.replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
  return text.substr(0, 1).toLowerCase() + text.substr(1);
}

export const capitalize = (text: string) => text ? text[0].toUpperCase() + text.slice(1) : ''

export function convertReactNodeToString(title: string | React.ReactNode): string {
  if (title === undefined) return '';
  if (typeof title === 'string') return title;

  if (typeof title === 'number' || typeof title === 'boolean') {
    return title.toString();
  }

  if (React.isValidElement(title)) {
    let flatTitle: string = ReactDOMServer.renderToStaticMarkup(title);
    flatTitle = flatTitle.replace(/(<([^>]+)>)/ig, '');
    return flatTitle;
  }

  return ''
}

export function getClassName<style>(
  options: { style?: style },
  className: keyof style,
  notset: string = ""
): string{
  return String(options && options.style && options.style[className] ? options.style[className] : notset)
}

export const convertRemToPx = (rem: string | number) => {
  const remValue = typeof rem == 'string' ? parseFloat(rem) : rem
  return parseFloat(getComputedStyle(document.documentElement).fontSize) * remValue
}

export const setIntervalRepetitions = (callback: (...args: any[]) => void, delay: number, repetitions: number): NodeJS.Timeout => {
  var retryAttempts = 0;

  var intervalID = setInterval(() => {
    callback();
    
    if (++retryAttempts !== repetitions) {
      return;
    }

    window.clearInterval(intervalID);
  }, delay);

  return intervalID
}

export const useDebounce = <T extends unknown[]>(
  callback: (...args: T) => void,
  delay: number,
) => {
  let timeoutTimer: NodeJS.Timeout;
 
  return (...args: T) => {
    clearTimeout(timeoutTimer);
 
    timeoutTimer = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};